import { createSelector } from 'reselect'

const select = (state) => state.related

const selectFetchingRelated = createSelector(
  select,
  (related) => related.isFetching
)

export { selectFetchingRelated }
